import React, { useState } from "react";
import { Dialog, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import OnlinePaymentsConfig from "../../DealerInfo/components/OnlinePaymentsConfig";
import * as Styled from "./styles";
import type { AvailableProvider } from "../../DealerInfo/components/OnlinePaymentsConfig/types";
import type { Provider } from "../../DealerAcquirersTable/types";

interface AddAcquirerModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: (
    provider?: Provider,
    meta?: { additionalStepPresented?: boolean },
  ) => void;
  merchantInfo?: { categoryCode: string } | null;
  availableProviders?: AvailableProvider[];
  dealerProviders?: Provider[];
}

const AddAcquirerModal: React.FC<AddAcquirerModalProps> = ({
  open,
  onClose,
  onSuccess,
  merchantInfo,
  availableProviders,
  dealerProviders,
}) => {
  const [isReviewMode, setIsReviewMode] = useState(false);

  const getTitle = () => {
    if (isReviewMode) return "Revisar dados do novo provedor";
    return "Adicionar provedor de pagamento";
  };

  const getDescription = () => {
    if (isReviewMode)
      return "Revise os dados preenchidos antes de confirmar a adição do provedor";
    return "Cadastre um novo provedor para recebimento de pagamentos";
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <Styled.DialogTitleStyled>
        <Styled.DialogTitleContainer>
          <Typography variant="h6">{getTitle()}</Typography>
          <Styled.DialogSubtitle variant="body1">
            {getDescription()}
          </Styled.DialogSubtitle>
        </Styled.DialogTitleContainer>
        <Styled.CloseButton onClick={onClose} size="small">
          <CloseIcon />
        </Styled.CloseButton>
      </Styled.DialogTitleStyled>

      <Styled.DialogContentNoPadding>
        <OnlinePaymentsConfig
          mode="ADD"
          onCancel={onClose}
          onReviewModeChange={setIsReviewMode}
          onSuccess={(provider, meta) => {
            setIsReviewMode(false);
            onSuccess?.(provider, meta);
            onClose();
          }}
          merchantInfo={merchantInfo}
          availableProviders={availableProviders}
          dealerProviders={dealerProviders}
        />
      </Styled.DialogContentNoPadding>
    </Dialog>
  );
};

export default AddAcquirerModal;
